import { render, staticRenderFns } from "./FeatureEdit.vue?vue&type=template&id=2f2bec04&scoped=true&"
import script from "./FeatureEdit.vue?vue&type=script&lang=js&"
export * from "./FeatureEdit.vue?vue&type=script&lang=js&"
import style0 from "./FeatureEdit.vue?vue&type=style&index=0&id=2f2bec04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bec04",
  null
  
)

export default component.exports